import { Navigate } from "react-router-dom";

import { usePermissions } from "@/features/rbac/hooks/usePermissions";
import { PlatformConfig } from "@/features/settings/components/PlatformConfig";

/**
 * Página de configuración de plataforma (viewmed_config).
 *
 * La ruta ya exige `settings:view`; esta comprobación se conserva como defensa
 * en profundidad por si alguien monta la página fuera del enrutador.
 */
export default function PlatformConfigPage() {
  const { can, isLoading } = usePermissions();

  if (isLoading) return null;

  if (!can("settings:view")) {
    return <Navigate to="/dashboard" replace />;
  }

  return <PlatformConfig />;
}
